import React, {useEffect, useRef, useState} from 'react';
import { B2BButton } from '../b2bbutton/b2bbutton';
import QuestionSummary from './survey-summary-component/survey-summary-component';
import { useModerationCheckMutation } from '../../redux/survey/survey.endpoints';
import { removeNotification, showNotification } from '../../redux/notification/notification.slice';
import { useDispatch } from 'react-redux';
import ValidationStepsModal from '../moderation-dialog/moderation-dialog';
import { findLocalSurveyErrors } from "../../services/surveys/surveys.helpers";
import { SurveyStatus } from '../../redux/survey/survey.types';
import { useNavigate } from "react-router-dom";
import { SurveyFull } from '../../redux/survey/survey.types';
import {partial} from "lodash";
import { ViewSurveyMode } from '../../pages/view-survey/view-survey.types';
import { useCreateInvoiceMutation } from "../../redux/payment/payment.endpoints";

// TODO remove dead code

interface SummaryCardProps {
  mode: ViewSurveyMode;
  survey?: SurveyFull,
}

const SummaryCard: React.FC<SummaryCardProps> = ({ mode, survey }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const extSurveyId = survey?.extSurveyId || '';
  const [moderationCheck, { isLoading: moderationLoading, data: moderationData, error: moderationError }] = useModerationCheckMutation({ fixedCacheKey: `moderation-check-${extSurveyId}` });
  const hasNavigated = useRef(false);
  // const subscription = useSelector((state: RootState) => getUserSubscription(state));
  const isInvoiceUser = true;
  const [createInvoice, { isSuccess: invoiceSuccess }] = useCreateInvoiceMutation();

  useEffect(() => {
    if (moderationData?.didPass !== true || mode === 'view') {
      return;
    }
    setModalOpen(false);
    dispatch(removeNotification({id: 'local-survey-error', summary: '', theme: 'warning'}));

    if (isInvoiceUser) {
      // void createInvoice({extSurveyId});

      // For now, we skip all invoicing, and proceed directly to launching survey.
      hasNavigated.current = true;
      navigate(`/view-survey?ext-survey-id=${extSurveyId}`);
      return;
    }
    hasNavigated.current = true;
    navigate(`/payment?ext-survey-id=${extSurveyId}`);
  }, [moderationData]);

  // useEffect(() => {
  //   if (!invoiceSuccess) {
  //     return;
  //   }

  //   hasNavigated.current = true;
  //   navigate(`/view-survey?ext-survey-id=${extSurveyId}`);
  // }, [invoiceSuccess]);

  useEffect(() => {
    moderationError && console.error('Error during moderation call:', moderationError);
  }, [moderationError]);

  const [isModalOpen, setModalOpen] = useState(false);

  useEffect(() => {
    setModalOpen(moderationLoading);
  }, [moderationLoading]);

  const handleSubmitCreate = async() => {
    if (!survey) {
      return;
    }

    if (survey.surveyStatus === SurveyStatus.Review) {
      navigate(`/payment?ext-survey-id=${extSurveyId}`, { replace: true });
      return;
    }

    const localError = findLocalSurveyErrors(survey);
    if (localError) {
      dispatch(showNotification({ id: 'local-survey-error', summary: localError, sticky: true, theme: "warning" }));
      return;
    }

    void moderationCheck({ extSurveyId });
  };

  return (
    <div className="flex flex-col grow">
      {mode === 'create' ? (
        <>
          <h2 className="mb-3 text-2xl">
            Summary
          </h2>
          <QuestionSummary
            survey={survey}
            mode={mode}
          />
          <div className="flex flex-col py-4">
            <B2BButton
              theme='blue'
              onClick={handleSubmitCreate}
              label={"Launch"}
            />
          </div>
          <ValidationStepsModal
            isModalOpen={isModalOpen}
            handleCloseModal={partial(setModalOpen, false)}
            showFooter={false}
          />
        </>
      ) : (
        <QuestionSummary
          survey={survey}
          mode={mode}
        />
      )}
    </div>
  );
};

export default SummaryCard;
